<template>
  <div styleName="switch_box" :style="style" @mouseenter="mouseover" @mouseleave="mouseout" :data-switch="cssStyle">
    <slot></slot>
    <ToggleIcon :show="showToggle" @toggle="togglePlayerPPT"/>
  </div>
</template>

<script>
  import styles from './index.scss'
  import CSSModules from 'vue-css-modules'
  import ToggleIcon from '@/components/ToggleIcon'
  import { mapGetters } from 'vuex'
  import { signalSdk } from '@/utils/getSDK'
  import * as types from '@/constants/index'

  export default {
    mixins: [CSSModules(styles)],
    data () {
      return {
        showToggle: false
      }
    },
    computed: {
      ...mapGetters(['roomDetail', 'cssStyle', 'pptSize']),
      style () {
        if (this.cssStyle === 'normal') {
          return `position:absolute;top: ${this.pptSize.top}px;left: ${this.pptSize.left}px;
              width: ${this.pptSize.width}px; height: ${this.pptSize.height}px;`
        } else {
          let totalWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
          return `position:absolute;top:0;right:-${320 - (totalWidth - this.pptSize.parentWidth)}px;`
        }
      }
    },
    methods: {
      mouseover () {
        if (this.cssStyle === 'change') {
          this.showToggle = true
        }
      },
      mouseout () {
        this.showToggle = false
      },
      // 切换互动课件和摄像头
      togglePlayerPPT () {
        if (this.roomDetail.data.roomRole === 1) {
          signalSdk.sendSwitchVideoPPT('1').then(() => {
            this.$store.commit(types.TOGGLE_PLAYER_AND_PPT, 'normal')
          })
        } else if (this.roomDetail.data.roomRole === 2) {
          this.$store.commit(types.TOGGLE_PLAYER_AND_PPT, 'normal')
        }
      }
    },
    components: {
      ToggleIcon
    }
  }
</script>
